import { useState } from "react";
import { FiSend } from "react-icons/fi";
import API from "../../api";

export default function Feedback({ user }) {
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);

    function sanitizeInput(input) {
        return input
            .replace(/[<>{}()"'`;$]/g, "") // retire caractères dangereux
            .trim();
    }
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("");

        if (!message) {
            setStatus("Please enter your feedback.");
            return;
        }

        const cleanMessage = sanitizeInput(message);

        if (!cleanMessage) {
        setStatus("Message contains invalid characters.");
        return;
        }

        try {
            setLoading(true);
            await API.post("/feedback", {
                userId: user.id,
                message: cleanMessage,
            });

            setStatus("✅ Feedback submitted successfully!");
            setMessage("");
        } catch (err) {
            console.error(err);
            setStatus("❌ An error occurred while submitting your feedback.");
        } finally {
            setLoading(false);
        }
    };

    return (
<div className="min-h-screen w-full bg-[#0D1117] flex items-start justify-center px-6 pt-16 pb-10 text-[#E6EDF3]">

        <div className="bg-[#161B22] border border-[#21262D] rounded-xl p-10 w-full max-w-xl">

        <h1 className="text-3xl font-semibold text-center tracking-tight mb-4">
            Send us your Feedback
        </h1>

        <p className="text-center text-[#9BA6B3] text-sm leading-relaxed mb-10 max-w-md mx-auto">
            Your feedback helps us build a better experience for everyone.  
            Tell us what we’re doing right — and where we can improve.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-7">
            
            {/* Message Input */}
            <div className="flex flex-col gap-1.5">
            <label className="text-[#9BA6B3] text-sm font-medium">
                Message
            </label>
            <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={6}
                className="bg-[#0D1117] border border-[#30363D] rounded-md px-3 py-3 w-full 
                text-[#E6EDF3] focus:outline-none focus:border-[#3B82F6] placeholder-[#6E7681] resize-none"
                placeholder="Share your thoughts with us..."
                required
            />
            </div>

            {/* Submit Button */}
            <button
            type="submit"
            disabled={loading}
            className="bg-[#3B82F6] hover:bg-[#2563EB] disabled:opacity-50 disabled:cursor-not-allowed
            text-white font-medium py-3 rounded-md transition flex items-center justify-center gap-2"
            >
            <FiSend size={18} />
            {loading ? "Sending..." : "Send Feedback"}
            </button>

            {/* Status Message */}
            {status && (
            <p
                className={`text-center font-medium ${
                status.startsWith("✅") ? "text-green-500" : "text-red-500"
                }`}
            >
                {status}
            </p>
            )}

        </form>
        </div>
    </div>
    );
}
